// src/common/components/transitionModalContent/useTransitionModalContent.ts
import { useState, useCallback } from "react";
import { getApi } from "../../../api/api";

const PRESETS = [5, 10, 15, 20, 30, 60];

export const useTransitionModalContent = (
  orderId: number,
  onClose: () => void,
) => {
  const [api] = useState(getApi);
  const [minutes, setMinutes] = useState("");
  const [loading, setLoading] = useState(false);

  const handlePreset = useCallback((preset: number) => {
    setMinutes(String(preset));
  }, []);

  const handleChange = useCallback((value: string) => {
    const filtered = value.replace(/\D/g, "");
    setMinutes(filtered);
  }, []);

  const handleSubmit = useCallback(async () => {
    const duration = Number(minutes);
    if (!duration || duration < 1) return;

    setLoading(true);
    try {
      await api.startTransition(orderId, duration);
      onClose();
    } catch (error) {
      console.error("Failed to start transition:", error);
    } finally {
      setLoading(false);
    }
  }, [minutes, orderId, api, onClose]);

  return {
    minutes,
    loading,
    presets: PRESETS,
    handlePreset,
    handleChange,
    handleSubmit,
    disabled: !minutes || Number(minutes) < 1,
  };
};
